import { ActionTypes } from "../contants/action-type.js";

import {
    getItems,
    createItem,
    updateItem,
    deleteItem,
    getSelectedItem,
    changeStatusItem
} from '../../services/ItemService.js';

export function getItemAction() {
    return (dispatch, getState) => {
        getItems()
            .then((response) => {
            dispatch(listItems(response.data));
        });
    };
}

export function getSelectedItemAction(id) {
    return (dispatch, getState) => {
        getSelectedItem(id).then((response) => {
            dispatch(selectedItem(response.data));
        });
    };
}
export function createItemAction(item, history) {
    return (dispatch, getState) => {
        createItem(item).then((response) => {
            dispatch(confirmCreateItem(response.data));
            history?.push('/menu');
        });
    };
}
export function updateItemAction(item,id, history) {
    return (dispatch, getState) => {
        console.log(item);
        updateItem(item,id).then((response) => {
            dispatch(confirmEditItem(response.data));
            history.push('/item');
        });
    };
}
export function changeStatusItemAction(category, id, history) {
    return (dispatch, getState) => {
        changeStatusItem(category, id).then((response) => {
            dispatch(listItems(response.data));
            history.push('/item');
        });
    };
}
export function deleteItemAction(id, history) {
    return (dispatch, getState) => {
        deleteItem(id).then((response) => {
            dispatch(listItems(response.data));
            history.push('/item');
        });
    };
}

export const listItems = (items) => {
    return {
        type: ActionTypes.LIST_ITEM,
        payload: items
    }
}
export const confirmCreateItem = (item) => {
    return {
        type: ActionTypes.CONFIRM_CREATE_ITEM,
        payload: item
    }
}
export const confirmEditItem = (item) => {
    return {
        type: ActionTypes.CONFIRM_EDIT_ITEM,
        payload: item
    }
}
export const selectedItem = (item) => {
    return {
        type: ActionTypes.SELECTED_ITEM,
        payload: item
    }
}
export const confirmDeleteItem = (item) => {
    return {
        type: ActionTypes.CONFIRM_DELETE_ITEM,
        payload: item
    }
}